var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.initStatus != 1)?_c('LoadingWidget',{attrs:{"status":_vm.initStatus},on:{"init":_vm.init}}):_c('div',[_c('b-card',[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fa fa-fw fa-dashboard mr-2"}),_vm._v("Dashboard")]),_c('hr'),_c('div',{staticStyle:{"height":"330px"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }